export enum DestinationType {
  SPLUNK = 'SPLUNK',
  SPLUNK_ES = 'SPLUNK_ES',
  SPLUNK_SOAR = 'SPLUNK_SOAR',
  ENCLAVE = 'ENCLAVE',
}

export type ApiCredentials = {
  apiKey: string,
  apiSecret: string,
};

export type Destination = {
  guid?: string,
  type: DestinationType,
  apiCredentials?: ApiCredentials,
};
